import ActivitiesDetailCard from 'features/WhatToDo/components/ActivitiesDetail';
import React from 'react';

const Activities = (): JSX.Element => {
  return <ActivitiesDetailCard />;
};
export default Activities;
